import React, { Fragment, useEffect } from "react";
import * as s from "./Client.styles";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import * as actions from "../../../store/actions/index";
import { useDispatch, useSelector } from "react-redux";
// components
import LineProgressBar from "../../../components/shared/lineProgressBar/LineProgressBar";
import FormikControl from "../../../components/shared/inputs/FormikControl";
import Documents from "../../../components/admin/client/documents/Documents";
import Spinner from "../../../components/shared/spinner/Spinner";

const Client = (props) => {
  let { clientId } = useParams();
  let dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const clientLoading = useSelector((state) => state.forManageAccount.loading);
  const clientData = useSelector((state) => state.forManageAccount.accountData);

  const clientProjects = useSelector((state) => state.forProjects.projects);

  // client projects
  useEffect(() => {
    dispatch(actions.fetchClientProjects(clientId));
    dispatch(actions.fetchAccountAdmin(clientId));
  }, []);
  useEffect(() => {
    dispatch(actions.clearProjectId());
  }, [location]);

  const initialValues = {
    selectOption: "",
  };
  const validationSchema = Yup.object({});
  const onSubmit = (values) => {
    console.log("Form data", values);
    console.log("Saved data", JSON.parse(JSON.stringify(values)));
  };

  const getTask = (pr_id) => {
    console.log(pr_id);
    dispatch(actions.fetchProjectMilestones(pr_id, 1, 10));
    dispatch(actions.SelectProjectId(pr_id));
    dispatch(actions.fetchProjectMilestones(pr_id, 1, 10));
  };
  //fetch milestone
  // let projectId = useSelector((state) => state.forMilestones.projectId);
  // console.log(clientProjects);

  let projectID = useSelector((state) => state.forMilestones.projectId);
  const projectMilestones = useSelector(
    (state) => state.forMilestones.milestones
  );
  const milestonesLoading = useSelector((state) => state.forMilestones.loading);
  // console.log(projectMilestones);

  let tasks = <s.Span>Please Select Project</s.Span>;
  if (projectMilestones !== null && milestonesLoading === false) {
    tasks = (
      <s.Tasks>
        {projectMilestones.length !== 0 &&
          projectMilestones.map((element) => {
            return (
              <s.SingleTaskContainer key={element.ts_id}>
                <s.displayColor isTaskDone={element.done}></s.displayColor>
                <s.Task>{element.name}</s.Task>
              </s.SingleTaskContainer>
            );
          })}
      </s.Tasks>
    );
  }

  return (
    <s.Wrapper>
      <s.MainContainer>
        {clientLoading === false ? (
          <Fragment>
            <s.HeaderContainer>
              <s.H1>Client Profile</s.H1>
              <s.Button
                onClick={() =>
                  history.push(`/clients/${clientId}/client-project`)
                }
              >
                Create Project
              </s.Button>
            </s.HeaderContainer>

            <s.ClientContainer>
              <s.HeaderClient>
                <s.ClientInfo>
                  <s.H1>{`${clientData.first_name} ${clientData.last_name}`}</s.H1>
                  <s.Span>{clientData.email}</s.Span>
                  <s.Span>{clientData.phone_number}</s.Span>
                </s.ClientInfo>

                <Formik
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={onSubmit}
                >
                  {(formik) => (
                    <Form style={{ width: "270px" }}>
                      <FormikControl
                        control="select"
                        name="selectOption"
                        onChange={(e) => {
                          getTask(e.target.value);
                          formik.setFieldValue("selectOption", e.target.value);
                        }}
                        value={formik.values.selectOption}
                      >
                        <option value="">PINNED PROJECTS</option>
                        {clientProjects &&
                          clientProjects.map((option) => {
                            return (
                              <option key={option.pr_id} value={option.pr_id}>
                                {option.name}
                              </option>
                            );
                          })}
                      </FormikControl>
                    </Form>
                  )}
                </Formik>
              </s.HeaderClient>

              <s.TasksContainer>
                <s.ProgressContainer>
                  <LineProgressBar complete={clientData.total_done} />
                  <s.H1>{clientData.total_done}</s.H1>
                </s.ProgressContainer>
                <s.HeaderContainer>
                  <s.H1>Tasks</s.H1>
                  <s.Button
                    disabled={!projectID}
                    onClick={() =>
                      history.push(`/clients/${clientId}/task-profile`)
                    }
                  >
                    Create Task
                  </s.Button>
                </s.HeaderContainer>
                <s.Tasks>{tasks}</s.Tasks>
              </s.TasksContainer>
            </s.ClientContainer>
          </Fragment>
        ) : (
          <s.SpinnerContainer>
            <Spinner />
          </s.SpinnerContainer>
        )}
      </s.MainContainer>

      <s.FolderContainer>
        <Documents />
      </s.FolderContainer>
    </s.Wrapper>
  );
};

export default Client;
